
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import logo from "../GROLINKZ_ICON.png";
import {useAuth} from "../contexts/authContext";
import {db} from "../firebase/firebase";
import course from "../photos/course.jpg";

const SplashScreen = () => {

    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to Home after 5 seconds
        const timer = setTimeout(() => {
            // // navigate(defaultPage);
            navigate("/content");
        }, 4500);

        return () => clearTimeout(timer); // Cleanup timer on unmount
    }, [navigate]);

    const { currentUser } = useAuth();
    const [fname, setFname] = useState("");

    useEffect(() => {
        const fetchUserName = async () => {
            if (currentUser) {
                try {
                    // Check if user data is in localStorage
                    const storedUserData = localStorage.getItem(`userName_${currentUser.uid}`);

                    if (storedUserData) {
                        // Use the stored user data
                        const userData = JSON.parse(storedUserData);
                        setFname(userData.fname);
                        // setAccountLevel(userData.accountLevel);
                    } else {
                        // Fetch user document from Firestore based on the current user's UID
                        const userDoc = await db.collection('Users').doc(currentUser.uid).get();
                        if (userDoc.exists) {
                            // Get the user's name from the document data
                            const userData = userDoc.data();
                            setFname(userData.fname);
                            // setAccountLevel(userData.accountLevel);
                            // Save user data to localStorage
                            localStorage.setItem(`userName_${currentUser.uid}`, JSON.stringify(userData));
                        } else {
                            console.log('User document not found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
        };

        fetchUserName();
    }, [currentUser]);

    const message = `Welcome ${fname}!`;
    const [animateLetters, setAnimateLetters] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setAnimateLetters(true), 1500); // after flipPopSwoosh
        return () => clearTimeout(timer);
    }, []);

    const title = `GROLINKZ`;
    const [animateTitle, setAnimateTitle] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setAnimateTitle(true), 3000); // after flipPopSwoosh
        return () => clearTimeout(timer);
    }, []);

    const [animateOut, setAnimateOut] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setAnimateOut(true), 4200); // after flipPopSwoosh
        return () => clearTimeout(timer);
    }, []);


    return (


        <div className={`relative bg-bgDark flex items-center justify-center h-dvh bg-gradient-to-br from-bgDark to-green-900 overflow-hidden`}>
            {/*/!* Spiral Background *!/*/}
            {/*<div className="absolute animate-fadeIn inset-0 flex items-center justify-center">*/}
            {/*    <div className="w-full h-full animate-heartBeatSlow bg-hypnotic-spiral"></div>*/}
            {/*</div>*/}


            <div className={`flex flex-col items-center justify-center animate-fadeIn ${animateOut ? 'animate-fadeOut' : ''}`}>

                {/* Hypnotic Spiral Background */}
                <div className={`absolute inset-0 flex items-center justify-center`}>
                    {/*<div className="w-full h-full animate-expandIn bg-hypnotic-spiral"></div>*/}
                    <img
                        alt=""
                        src={course}
                        className="absolute inset-0 object-cover opacity-50 size-full"
                    />
                </div>


                <h1 className="absolute font-semibold mb-72 text-white text-6xl tracking-widest animate-expandInSlow">
                    {message.split('').map((char, idx) => (
                        <span
                            key={idx}
                            className={`inline-block ${
                                animateLetters && char !== ' ' ? 'animate-letterBounce' : ''
                            }`}
                            style={{
                                animationDelay: animateLetters ? `${idx * 80}ms` : '0s',
                                animationFillMode: 'both',
                            }}
                        >
                        {char === ' ' ? '\u00A0' : char}
                      </span>
                    ))}
                </h1>


                {/* GroLinkz Logo and Text */}
                <div className="text-center relative z-10 animate-epicReveal">
                    <div className="flex justify-center mb-16">
                        <img
                            alt=""
                            src={logo}
                            className="absolute w-24 z-50"
                        />
                    </div>
                    <h1 className="text-4xl font-bold text-white tracking-widest animate-fade-in">
                        {title.split('').map((char, idx) => (
                            <span
                                key={idx}
                                className={`inline-block ${
                                    animateTitle ? 'animate-raiseSpinDrop' : ''
                                }`}
                                style={{
                                    animationDelay: animateTitle ? `${idx * 80}ms` : '0s',
                                    animationFillMode: 'both',
                                }}
                            >
                          {char}
                        </span>
                        ))}
                    </h1>
                </div>

            </div>



        </div>

    );
};

export default SplashScreen;
